import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent  implements OnInit {

  loginForm: FormGroup = new FormGroup({});
  formSubmitted:boolean = false;
  constructor(public router: Router,private http: HttpService,private config:Config,
    private loader:LoaderService,private fb: FormBuilder,
    public dialog: MatDialog,) { }

  ngOnInit() {
    this.inializeLoginForm();
  }
  onClickLogin(){
    this.router.navigate(['/login']);
  }
  inializeLoginForm(){
    this.loginForm = this.fb.group({
      email: ['', [Validators.required,Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
    });
  }
  onClickForgotPassword(){
    this.formSubmitted = true;
    if (this.loginForm.valid) {
      this.formSubmitted = false;
      this.loginForm.controls['email'].setValue(this.loginForm.value.email?.trim());
      const request = {
        "email": this.loginForm.value.email,
      }
      this.loader.simpleLoaderWithDuration();
      this.http.callPostServiceForLogin(this.config.forgotPassword, request)
        .subscribe((data: any) => {
          this.loader.dismissLoader();
          if(data?.success){
            const successdialogRef=  this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: 'Password Reset Link Sent successfully.',
                btn2: 'OK',
                btn2BgColor: '#F6921E',
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.router.navigate(['/login']);
            });
          }else{
            const successdialogRef=  this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data?.data,
                btn2: 'OK',
                btn2BgColor: '#F6921E',
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              // this.router.navigate(['/login']);
            });
          }
        }, (error: any) => {
        }, () => { });
    }
  }
}
